module.exports = require('style-inject')
